export default {
  template: "#vue-sidebar",
  delimiters: ['${', '}'],
  props: ['category'],
  methods: {
    switchCategory: function (e) {
      window.location = e.target.value;
    }
  }
}